import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Api } from './api.service';

@Injectable({
  providedIn: 'any',
})
export class ApiMedia extends Api<any> {
  constructor(http: HttpClient) {
    super(http);
    this.resource = 'media';
  }

  public viewMedia(uuid: string) {
    const storageBase = this.base.replace(/\/api\/?$/, '');

    return this.http.get(`${storageBase}/${this.resource}/${encodeURIComponent(uuid)}`, {
      headers: new HttpHeaders({
        Authorization: `Bearer ${this.token}`,
      }),
      responseType: 'blob',
    });
  }
}